import { ScreenRoute } from "./ScreenRouteConstant"

export const dashboardFAQ = [
  {
    'catName': 'About Aayu',
    'active': false,
    'quesList': [{
      "title": "Why should I use aayu.app?",
      "description": "Through Aayu.app you can order medicine online and get it delivered in under 2 hours from your nearby chemist store. You can also consult with specialist doctors in India at affordable prices within 30 minutes.",
      "active": false
    },
    {
      "title": "Is Aayu App available on Apple app store?",
      "description": "Currently, the app is available only on Google playstore. You can use Aayu as a web app on apple devices currently' for home.",
      "active": false
    },
    {
      "title": "What are the services that I can avail from Aayu?",
      "active": false,
      'boldDesc': [{ nText: `Aayu is becoming the go to service for you. You can -` }, { bText: 'Order Medicines - ', nText: 'Order medicines and get the delivery within 2 hours from nearby chemist store.' },
      { bText: 'Doctor Consultations - ', nText: 'Talk to a doctor anywhere in under 30 mins across 35+ specialities.' },
      { bText: 'Lab Tests - ', nText: 'Get 160+ lab tests done from home.' },
      { bText: 'Save Records - ', nText: 'Share medical data in a secure way between doctor-patient while removing the hassle of storing and maintaining hard copies of medical records.' },
      { bText: 'Aayu Cards - ', nText: 'You can opt for Aayu Card, a heavily discounted yearly Health Subscription of consultation from specialist doctors for your entire family.' },
      ]
    },
    ]
  },
  {
    'catName': 'Order Medicines',
    'active': false,
    'quesList': [
      {
        "title": "Can I order medicines online?",
        "description": "Yes, you can order medicines from Aayu.app from the comfort of your home, which will be delivered to you by the chemist store within 2 hrs.",
        "active": false,
        // 'link': 'https://getaayu.medcords.com/6QYe',
        // 'linkType': 'linkRedirect'
      },
      {
        "title": "How can I order medicines from aayu.app?",
        "description": `Use "Order Medicine" feature to order medicines and wellness products from your nearest chemist stores.\nGo to home page -> Order Medicines -> Select location -> Turn on "GPS" or go to 'Use current location' -> Select any store from the list of nearby chemist stores --> Search medicines or order with photo here -> Place your order.`,
        "active": false,
        'linkType': 'pageRedirect',
        'link': 'Click here to go on the order medicine feature on the home page',
        'redirectPage': ScreenRoute.search_locality
      },
      {
        "title": "How can I find the nearest chemist store?",
        "description": `Use the 'Order Medicine' feature to find and order from your nearby chemist stores.\nGo to home page -> Order Medicines -> Select location -> Turn on ""GPS"" or go to 'Use current location' -> You can see the list of chemist stores in your area.`,
        "active": false,
        'linkType': 'pageRedirect',
        'link': 'Click here to go on the order medicine feature on the home page',
        'redirectPage': ScreenRoute.search_locality
      },
      {
        "title": "Can prescriptions provided on aayu.app be used to buy medicines from chemist stores?",
        "description": `Yes, prescriptions received on aayu.app can be used to buy medicines. You can share the digital prescription with the chemist stores and order from Aayu website or app and get the medicines delivered to your home. Otherwise you can download and take the print if you visit a chemist store that does not accept digital prescription.`,
        "active": false
      },
      {
        "title": "How can I make payment for ordered medicines on aayu.app?",
        "description": "You can pay via cash for the medicines you have ordered.",
        "active": false
      },
      {
        "title": "Can I pay online for my order?",
        "description": `Currently cash on delivery is available for any order of medicines or products on aayu.app.\nOnline payment feature is currently available on the app.\nDownload the app `,
        "active": false,
        'link': 'https://getaayu.medcords.com/6QYe',
        'linkType': 'linkRedirect'
      },
      {
        "title": "I didn't receive any response from chemist store. What should I do?",
        "description": `If you have not received any response from chemist store then you can call or chat with the chemist store.\nGo to the home page -> Recent activities -> Track Order -> click on phone symbol to call or 'message chemist store' to chat.`,
        "active": false
      },
      {
        "title": "What are the benefits that I will get when I order medicines from aayu.app?",
        "description": `You get to connect online with your nearby chemist stores, buy medicines from the comfort of your home which saves money and time for you.\nYou can see offers on different product by different chemist stores at one place.`,
        "active": false
      },
      {
        "title": "Can I order the discounted products and medicines together?",
        "description": `Yes, you can order the discounted products (which are displayed by chemist store) & medicines together.`,
        "active": false
      },
      {
        "title": "How would I know which chemist store is the nearest and the best for me?",
        "description": `You can see the chemist store rating and distance in the listing of your nearby chemist stores. Store rating assures that it's the best for you & distance assures you that this store is the nearest.`,
        "active": false
      },
      {
        "title": "Can I talk to the chemist store I have selected? How can I do that?",
        "description": `Yes, you can talk to the chemist store you have place order to.\nGo to the home page -> Recent activities -> Track Order -> click on phone symbol to call.`,
        "active": false
      },
      {
        "title": "Its saying location not found, what does that mean?",
        "description": `It means that your GPS or location is not enabled on your device (computer or mobile).`,
        "active": false
      },
      {
        "title": "How can I find out if Aayu delivers orders in my area?",
        "description": `Once you have added your location in the web page, a list of available chemist stores in the area appears. In case you are unable to see the list we request you to update your location.`,
        "active": false
      },
    ]
  },
  {
    'catName': 'Talk To Doctor',
    'active': false,
    'quesList': [
      {
        "title": "How will the doctor contact me?",
        "description": `The doctor will contact you on the number that you have submitted while placing the consultation request.\nWe request you to choose a number that has a good network connection and will be available with you.`,
        "active": false
      },
      {
        "title": "How much would a consultation cost?",
        "description": `The first consultation is available at ₹199 only. The cost of second consultation is ₹249 only, if you opt for Aayu card plan, you can save up to 50% on each consultation for 1 year.\nThe fees for consultation in any category on Aayu is the same.`,
        "active": false,
      },
      {
        "title": "Can I save on the fee for each consultation?",
        "description": `Yes, you can absolutely save fees on doctor consultations. When you opt for Aayu card plan, you can save up to 50% on each consultation. With the plan you can enjoy payment-free consultations for the entire year for your family.`,
        "active": false,
        'linkType': 'pageRedirect',
        'link': 'Click here to see Aayu subscription plans',
        'redirectPage': ScreenRoute.acs_plans
      },
      {
        "title": "How can I make payment for consultation?",
        "description": `All online payment methods like UPI, Paytm, netbanking, debit cards, etc are supported.\nIf you cannot pay online, you can visit a Aayu Chemist (Chemist store associated with us) near your home and take doctor consultations through them.`,
        "active": false
      },
      {
        "title": "Will I have to schedule an appointment before consulting a doctor? ",
        "description": `Not at all. On Aayu, you don't need to book an appointment for consultations. You can simply select the problem from the categories mentioned and describe your issues. A specialist doctor will call you within the next 30 minutes.`,
        "active": false
      },
      {
        "title": "What problems can be consulted here?",
        "description": `You can consult from doctors available for 37 different specialities. The problems ranging from skin issues, hairfall, sexual problems for men and women, acidity, bone and joint pains, BP, diabetes, viral infections, child issues etc. can be consulted.\nWith a team of 5000+ specialist doctors, Aayu provides solutions for your problems at your home.`,
        "active": false
      },
      {
        "title": "How will I get a doctor's prescription?",
        "description": `All past prescriptions will be available on the home page of this website. Whenever you consult, you will also get an SMS on your registered mobile number with the link to the doctor's prescription.\nIf you have the Aayu app downloaded on your phone you can find all your prescriptions and reports organised in the 'My Records' section.`,
        "active": false,
        'boldText': ' Download the app',
        'link': 'https://getaayu.medcords.com/6QYe',
        'linkType': 'linkRedirect'
      },
      {
        "title": "Can I use the prescription for mediclaims or buying medicines?",
        "description": `Yes. The prescription shared with you is in compliance with ICMR(Indian Council of Medical Research) guidelines. You can use this to buy medicines at chemist stores or use them for mediclaims.\nCheck out a sample prescription- link(A format will be shown in the popup with cross button)`,
        "active": false,
        'linkType': 'imageRedirect',
        'link': 'Check out a sample prescription',
        'rediectImageUrl': '/images/prescription/prescription-formate.png'
      },
      {
        "title": "Can I take follow up with the same doctor again?",
        "description": "Yes. Follow up is available on Aayu app. The follow ups are free for the designated period of 7 days from the last consultation. Download the app",
        "active": false,
        'link': 'https://getaayu.medcords.com/6QYe',
        'linkType': 'linkRedirect'
      }]
  },
  {
    'catName': 'Aayu Card',
    'active': false,
    'quesList': [
      {
        "title": "What is Aayu Card?",
        "description": `Aayu card is your family's health security plan.\nWhen you opt for the Aayu card plan you can save up to 50% on each consultation. It gives you and your family the freedom to consult with specialist doctors from the comfort of your home for the entire year.`,
        "active": false
      },
      {
        "title": "Why should I purchase Aayu Card?",
        "description": `Benefits that you get when you buy Aayu card:
1. Get ₹1 lakh worth of accidental death insurance FREE.
2. Can be used by entire family to take consultations.
4. No additional cost of follow ups (within the designated time).
5. You save money spent on family's healthcare.
6. Valid for 12 months. 
        `,
        "active": false
      },
      {
        "title": "What is the price and plans of Aayu card purchase?",
        "aayuPriceHead": 'Consultations         Aayu Card Plans',
        "description": "    25                                     ₹3249/-                            \n    12                                     ₹1899/-\n    05                                     ₹899/-",
        "active": false

      },
      {
        "title": "How many members can take consultations via Aayu card?",
        "description": `You can add all the members of your family on Aayu and enjoy the benefits of Aayu card.`,
        "active": false
      },
      {
        "title": "How can I purchase Aayu Card?",
        "description": `You can purchase the Aayu card plan by clicking on "Aayu card banner" on the home page of aayu website or app. We request you to choose a plan that best suits your family's requirements, and proceed to make the payment. You can also purchase the Aayu card at your nearest Aayu Chemist (your nearby chemist store associated with us) or you can call on +91 781-681-1111.`,
        "active": false
      },
      {
        "title": "When can I get a discount on an Aayu card purchase?",
        "description": `We regularly update our Aayu users about the discounts through notifications on the registered numbers and pop-ups on the app.`,
        "active": false
      },
      {
        "title": "Where can I use Aayu Card?",
        "description": `Aayu card is used to take doctor consultations from Aayu website or app.\nIf you don't have a smart phone you can take the consultations with the help of your nearest Aayu Chemist (your nearby chemist store associate with us). Your doctor consultation using your Aayu card can also be facilitated by our customer care team. Please connect with the team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Do I need to pay for consultations even after I have bought Aayu card?",
        "description": `Our system automatically recognises your Aayu card plan. You don't have to make any additional payments when you are opting for consultations.`,
        "active": false
      },
      // {
      //   "title": "How can I use Aayu Card?",
      //   "description": "It will be utilized automatically when you make an E-consult or follow up, no additional payment will be required for submitting the consultation case ",
      //   "active": false
      // },
      {
        "title": "My Aayu Card is not active even after payment, why?",
        "description": `The card is generally activated immediately after the process of payment is complete. If you are unable to see your card, please feel free to connect with our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": `I have Aayu card but seeing payment option during consultation. What should I do?`,
        "description": `Please make sure that you are booking the consultation from the same number that is registered for Aayu card. If you are not we request you to use the same number so you can enjoy the benefits of the card.\nIn case you are unable to resolve the issue please feel free to connect with our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Can I use Aayu Card at my nearby hospital?",
        "description": `Aayu card is valid only for online consultations with doctors on Aayu website and app.\nYou can also buy Aayu card from the Aayu app, or website, through a registered Aayu Chemist or through our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Will I get any discount on medicine purchases from Aayu card?",
        "description": `With Aayu card you save only on doctor consultations.\nAny discounts on medicines and products on the platforms are offered by chemist stores. You can see these discounts in the 'Order Medicine' section of the web app.`,
        "active": false
      },
      {
        "title": "If I am not able to consume 25 consultations in 1 year, can I use in next year?",
        "description": "The validity of the Aayu card is for 1 year (365 days). If you are unable to consume the consultations during this time, the card will expire.",
        "active": false
      },
      {
        "title": "I have exhausted my consultation but validity is pending, can I still use Aayu Card ?",
        "description": `If you have exhausted the number of consultations available on your Aayu card, you will have to buy another card or pay the listed amount.\nWhen you choose to buy another Aayu card we request you to buy the one that fulfills your family's medical needs.`,
        "active": false
      }
      ,]
  },

]

export const AayuFAQs = [
  {
    'catName': 'Aayu Card',
    'active': true,
    'hideHeader': true,
    'quesList': [
      {
        "title": "What is Aayu Card?",
        "description": `Aayu card is your family's health security plan. When you opt for the Aayu card plan you can save up to 50% on each consultation. It gives you and your family the freedom to consult with specialist doctors from the comfort of your home for the entire year.`,
        "active": false
      },
      {
        "title": "Why should I purchase Aayu Card?",
        "description": `Benefits that you get when you buy Aayu card:
        1. Get ₹1 lakh worth of accidental death insurance FREE.
        2. Can be used by entire family to take consultations.
        4. No additional cost of follow ups (within the designated time).
        5. You save money spent on family's healthcare.
        6. Valid for 12 months. 
        `,
        "active": false
      },
      {
        "title": "What is the price and plans of Aayu card purchase?",
        "description": "Consultations         Aayu Card Plans  \n25                                  ₹3249/-                                    \n12                                  ₹1899/-\n05                                  ₹899/-",
        "active": false

      },
      {
        "title": "How many members can take consultations via Aayu card?",
        "description": `You can add all the members of your family on Aayu and enjoy the benefits of Aayu card.`,
        "active": false
      },
      {
        "title": "How can I purchase Aayu Card?",
        "description": `You can purchase the Aayu card plan by clicking on "Aayu card banner" on the home page of aayu website or app. We request you to choose a plan that best suits your family's requirements, and proceed to make the payment. You can also purchase the Aayu card at your nearest Aayu Chemist (your nearby chemist store associated with us) or you can call on +91 781-681-1111.`,
        "active": false
      },
      {
        "title": "When can I get a discount on an Aayu card purchase?",
        "description": `We regularly update our Aayu users about the discounts through notifications on the registered numbers and pop-ups on the app.`,
        "active": false
      },
      {
        "title": "Where can I use Aayu Card?",
        "description": `Aayu card is used to take doctor consultations from Aayu website or app. If you don't have a smart phone you can take the consultations with the help of your nearest Aayu Chemist (your nearby chemist store associate with us). Your doctor consultation using your Aayu card can also be facilitated by our customer care team. Please connect with the team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Do I need to pay for consultations even after I have bought Aayu card?",
        "description": `Our system automatically recognises your Aayu card plan. You don't have to make any additional payments when you are opting for consultations.`,
        "active": false
      },
      // {
      //   "title": "How can I use Aayu Card?",
      //   "description": "It will be utilized automatically when you make an E-consult or follow up, no additional payment will be required for submitting the consultation case ",
      //   "active": false
      // },
      {
        "title": "My Aayu Card is not active even after payment, why?",
        "description": `The card is generally activated immediately after the process of payment is complete. If you are unable to see your card, please feel free to connect with our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": `I have Aayu card but seeing payment option during consultation. What should I do?`,
        "description": `Please make sure that you are booking the consultation from the same number that is registered for Aayu card. If you are not we request you to use the same number so you can enjoy the benefits of the card. In case you are unable to resolve the issue please feel free to connect with our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Can I use Aayu Card at my nearby hospital?",
        "description": `Aayu card is valid only for online consultations with doctors on Aayu website and app.
        You can also buy Aayu card from the Aayu app, or website, through a registered Aayu Chemist or through our customer care team on +91 781 681 1111.`,
        "active": false
      },
      {
        "title": "Will I get any discount on medicine purchases from Aayu card?",
        "description": `With Aayu card you save only on doctor consultations.
        Any discounts on medicines and products on the platforms are offered by chemist stores. You can see these discounts in the 'Order Medicine' section of the web app.`,
        "active": false
      },
      {
        "title": "If I am not able to consume 25 consultations in 1 year, can I use in next year?",
        "description": "The validity of the Aayu card is for 1 year (365 days). If you are unable to consume the consultations during this time, the card will expire.",
        "active": false
      },
      {
        "title": "I have exhausted my consultation but validity is pending, can I still use Aayu Card ?",
        "description": `If you have exhausted the number of consultations available on your Aayu card, you will have to buy another card or pay the listed amount.
        When you choose to buy another Aayu card we request you to buy the one that fulfills your family's medical needs.`,
        "active": false
      }
      ,]
  },
]